<div class="container-fluid service-bg from-top-pad">
    <div class="row">
        <div class="col-md-8 offset-2">
            <div [innerHTML]="doc"></div>
        </div>
    </div>
</div>